import type { SVGProps } from 'react'

export const ShareChart = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19 15.2196C18.5033 16.3971 17.7263 17.4347 16.7371 18.2417C15.7478 19.0487 14.5764 19.6005 13.3253 19.8489C12.0741 20.0973 10.7813 20.0347 9.55992 19.6666C8.33849 19.2984 7.22562 18.636 6.31861 17.7372C5.41159 16.8384 4.73805 15.7305 4.35687 14.5105C3.97568 13.2905 3.89846 11.9954 4.13196 10.7386C4.36546 9.48175 4.90256 8.30138 5.69631 7.30067C6.49006 6.29995 7.51629 5.50937 8.68528 4.99805"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 11.998C20 10.9475 19.7931 9.90718 19.391 8.93658C18.989 7.96597 18.3997 7.08406 17.6569 6.34119C16.914 5.59832 16.0321 5.00905 15.0615 4.60701C14.0909 4.20497 13.0506 3.99805 12 3.99805V11.998H20Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
